var React = require('react');
var ReactNative = require('react-native');
var createReactClass = require('create-react-class');
var {
  View,
} = ReactNative;

var MapView = createReactClass(
{
  getDefaultProps : function()
  {
    return {
    }
  },

  getInitialState : function()
  {
    return {
    }
  },

  componentDidMount : function()
  {
  },

  render: function()
  {
    return <View style={this.props.style} />
  }
});

MapView.Marker = createReactClass(
{
  getDefaultProps : function()
  {
    return {
    }
  },

  getInitialState : function()
  {
    return {
    }
  },

  componentDidMount : function()
  {
  },

  render: function()
  {
    return <View style={this.props.style} />
  }
});

module.exports = MapView;
